import { motion } from "framer-motion";
import { Phone, Headphones, FileText, CalendarDays, Inbox, ShoppingBag, Search, PartyPopper } from "lucide-react";
import { Reveal, staggerContainer, staggerItem } from "@/components/site/Reveal";

const SERVICES = [
  { icon: Phone, title: "Gestión de llamadas", desc: "Atendemos, filtramos y devolvemos llamadas en tu nombre." },
  { icon: Headphones, title: "Atención al cliente", desc: "Correos y WhatsApp respondidos con tu tono de marca." },
  { icon: FileText, title: "Administración", desc: "Facturas, presupuestos y seguimiento de cobros al día." },
  { icon: CalendarDays, title: "Gestión de agenda", desc: "Citas, reuniones y recordatorios siempre coordinados." },
  { icon: Inbox, title: "Bandeja de entrada", desc: "Filtramos, respondemos y priorizamos tu correo." },
  { icon: ShoppingBag, title: "Compras y recados", desc: "Pedidos, devoluciones y gestiones del día a día." },
  { icon: Search, title: "Investigación e informes", desc: "Comparativas, proveedores y datos listos para decidir." },
  { icon: PartyPopper, title: "Eventos y reservas", desc: "Restaurantes, salas, comidas de empresa y regalos." },
];

export default function ServicesSection() {
  return (
    <section id="servicios" className="scroll-mt-24 py-20 sm:py-24" data-testid="services-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal className="text-center text-[13px] uppercase tracking-[0.12em] text-brand-gray">
          Servicios
        </Reveal>
        <Reveal className="mx-auto mt-3 max-w-2xl text-center text-3xl sm:text-4xl font-medium tracking-tight text-brand-ink">
          Todo lo que hacemos por ti
        </Reveal>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-40px" }}
          className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4"
        >
          {SERVICES.map(({ icon: Icon, title, desc }) => (
            <motion.div
              key={title}
              variants={staggerItem}
              className="group rounded-[14px] border border-brand-line bg-white p-6 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_12px_30px_rgba(31,41,55,0.08)]"
              data-testid={`service-card-${title.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-[12px] bg-brand-indigo/8 transition-colors duration-300 group-hover:bg-brand-indigo/12">
                <Icon size={22} className="text-brand-indigo" strokeWidth={1.75} />
              </div>
              <h3 className="mt-4 text-[16px] font-medium text-brand-ink">{title}</h3>
              <p className="mt-1.5 text-[14px] leading-relaxed text-[#5F5E5A]">{desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
